import { faCheck, faHourglass } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect } from "react"
import { ActionFunctionArgs, useFetcher, useSearchParams } from "react-router-dom"

import { fetchAPI } from "../utils"
import { Header, ProcessingItem } from "../components"

import type { Payload } from "./microservices-messages"

async function action({ request }: ActionFunctionArgs) {
  const formData = await request.formData()
  const url = new URL(request.url)

  const queueName = url.searchParams.get("queueName") ?? ""

  const res = await fetchAPI(
    `/api/queues/processing/${queueName}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        messageIds: [],
        query: formData.get("query") ?? "",
      }),
    },
    "raw",
  )

  if ([201, 403].includes(res.status)) return { items: [], totalCount: 0 }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return await (res.result?.json() ?? { items: [], totalCount: 0 })
}

const Route = () => {
  const [search] = useSearchParams()
  const fetcher = useFetcher<{ items: WorkflowItem[]; totalCount: number }>()

  useEffect(() => {
    if (fetcher.state !== "idle") return

    const timerId = setInterval(() => fetcher.submit(null, { method: "post" }), 5 * 1e3)
    return () => clearInterval(timerId)
  }, [fetcher])

  return (
    <div className="flex min-h-screen w-full flex-col items-start justify-start gap-5 overflow-y-auto overflow-x-hidden bg-base-300 px-5 py-5 scrollbar-none">
      <div className="w-full space-y-5">
        <Header />
        <div className="grid w-full grid-cols-[minmax(0,20%),minmax(65%,1fr)] grid-rows-3 gap-3">
          <div className="text-black col-start-1 row-span-full flex min-h-0 min-w-0 items-center justify-start gap-2">
            <span className="text-sm font-bold">{search.get("queueName")} - Processing</span>
            <FontAwesomeIcon icon={fetcher.state !== "idle" ? faHourglass : faCheck} />
          </div>
          <fetcher.Form
            method="post"
            className="col-start-2 row-start-1 flex min-h-0 min-w-0 items-center justify-end gap-2"
          >
            <input
              type="text"
              name="query"
              id="regex-input"
              placeholder="Enter search term (regex)"
              className="input input-bordered input-accent input-sm basis-1/2 bg-base-100 py-1 px-2 text-sm text-base-content focus:outline-none"
            />
            <button type="submit" className="text-black btn btn-outline btn-accent btn-sm text-sm">
              Go!
            </button>
          </fetcher.Form>
        </div>
      </div>
      <div className="divider" />
      <div
        className="
      flex w-full flex-col gap-2 rounded text-base-content
      overflow-y-auto h-[42.5rem]"
      >

        {fetcher.data?.items.map((message) => (
          <ProcessingItem key={`${message.workflowId}-${message.step}-${message.timeStamp}`} message={message} />
        ))}
      </div>
    </div>
  )
}

Route.action = action

export default Route

export interface WorkflowItem {
  workflowId: string
  payload: Payload
  step: string
  serviceName: string
  pod: string | null
  timeStamp: string
  stackTrace: string | null
}
